export const COLOR_MODE_TYPES = {
  STATIC: 'static',
  DYNAMIC: 'dynamic',
}
